var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-10 w-full flex"},_vm._l((_vm.BarChartData),function(bar,index){return _c('div',{key:index,style:({
      width: bar.percent + '%',
      'background-color': bar.color,
    })})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }